import { render, staticRenderFns } from "./DifferentButton.vue?vue&type=template&id=78e3ac83&"
import script from "./DifferentButton.vue?vue&type=script&lang=js&"
export * from "./DifferentButton.vue?vue&type=script&lang=js&"
import style0 from "./DifferentButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports